import React from "react";
import { Grid, Typography } from "@material-ui/core";
// import calculateSpacing from "./calculateSpacing";

// A simple component to show an image and title clearly organized.
const solutions = [
  { img: "/assets/solutions/clock.svg", title: "24/7 Emotional Support", alt: "Clock icon representing 24/7 emotional support" },
  { img: "/assets/solutions/brain.svg", title: "Deeply Personalized Interactions", alt: "Brain icon representing deeply personalized interactions" },
  { img: "/assets/solutions/bridge.svg", title: "Bridge Therapy Gaps", alt: "Bridge icon symbolizing the bridging of therapy gaps" },
  { img: "/assets/solutions/privacy.svg", title: "Commitment to Privacy & Affordability",  alt: "Shield icon representing commitment to privacy and affordability/ cheap therapy"}
];

function SolutionSection(props) {

  return (
    <div style={{ backgroundColor: "#FFFFFF", paddingTop: 60, paddingBottom: 60,paddingLeft: 16,paddingRight: 16, marginTop: "80px"}}>
      <Typography
        variant="h3"
        align="center"
        style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 400,
          color: "#361C10",
          marginBottom: "80px"
        }}
      >
        How Wolfe Changes the Narrative
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {solutions.map((item) => (
          <Grid item xs={12} sm={6} md={3} style={{ textAlign: "center" }} key={item.title}>
            <img 
              src={item.img} 
              alt={item.title} 
              style={{ 
                width: "120px", 
                height: "120px", 
                objectFit: "contain",
                marginBottom: "15px"
              }}
            />
            <Typography 
              variant="h6" 
              align="center"
              style={{
                fontFamily: "'Lato', sans-serif",
                fontWeight: 600,
                fontSize: "1.5rem"
              }}
            >
              {item.title}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default SolutionSection;


